import './Section3.css';

import { IonCard, IonCardContent, IonItem, IonLabel, IonRow, IonText, useIonToast } from '@ionic/react';
import { giftOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../components/button/ActionButton';
import InputItem from '../../components/input/InputItem';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { ApplyCouponPostAction } from '../../redux/actions/Shop';
import SlideContent from '../../components/slide-content/SlideContent';

interface Props {
    formProvider: any,
    formProvider2: any,
    data: any,
    setCartProducts: any,
    setCartSummary: any
}

const Section3: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch();

    const couponApplyPost = useAppSelector(state => state.applyCouponPost);
    const { form_loading, resp } = couponApplyPost;

    const applyCoupon = () => {
        if (props.formProvider.validation(props.formProvider.form)) {
            dispatch(ApplyCouponPostAction(props.formProvider.form.coupon_code.value, props.formProvider2.form.province.value));
        }
    }

    useEffect(() => {
        if (resp != null && !form_loading) {
            if (resp.result) {
                // toast({ message: resp.message, duration: 2000, color: "primary" })

                props.setCartProducts(resp.items)
                props.setCartSummary(resp.summary);

                //formProvider.reset();
            } else {
                toast({ message: resp.message, duration: 2000, color: "danger" })
            }
        }
    }, [form_loading])

    return <SlideContent type="navbar" class="section3">
        <div>
            <IonCard className="delivery">
                <IonCardContent>
                    <IonItem>
                        <IonText className="header" color="dark">سفارش شما با مشخصات زیر ارسال خواهد شد.</IonText>
                    </IonItem>
                    <IonItem>
                        <IonLabel color="medium">نام و نام خانوادگی</IonLabel>
                        <IonText>{props.formProvider2.form.full_name.value}</IonText>
                    </IonItem>
                    <IonItem>
                        <IonLabel color="medium">استان / شهرستان</IonLabel>
                        <IonText>{props.formProvider2.form.province.value} / {props.formProvider2.form.city.value}</IonText>
                    </IonItem>
                    <IonItem>
                        <IonLabel color="medium">آدرس</IonLabel>
                        <IonText>{props.formProvider2.form.address.value}</IonText>
                    </IonItem>
                    <IonItem lines="none">
                        <IonLabel color="medium">کد پستی</IonLabel>
                        <IonText>{props.formProvider2.form.postal_code.value}</IonText>
                    </IonItem>
                </IonCardContent>
            </IonCard>
            <IonCard>
                <IonCardContent>
                    <InputItem name="coupon_code" label="کد تخفیف" type="text" icon={giftOutline} provider={props.formProvider} />
                    <ActionButton loading={form_loading} class="apply-coupon" text="اعمال" compact click={applyCoupon} />
                </IonCardContent>
            </IonCard>
            <IonCard className="bill">
                <IonCardContent>
                    <IonItem>
                        <IonLabel color="medium">هزینه ارسال</IonLabel>
                        <IonText>{Number(props.data.summary?.delivery).toPrice()}</IonText>
                    </IonItem>
                    <IonItem>
                        <IonLabel color="medium">هزینه بسته بندی</IonLabel>
                        <IonText>{Number(props.data.summary?.packing).toPrice()}</IonText>
                    </IonItem>
                    <IonItem>
                        <IonLabel color="medium">تخفیف</IonLabel>
                        <IonText>{Number(props.data.summary?.discount).toPrice()}</IonText>
                    </IonItem>
                    <IonItem lines="none">
                        <IonLabel color="danger">مبلغ قابل پرداخت</IonLabel>
                        <IonText color="danger"><strong>{Number(props.data.summary?.total).toPrice()}</strong></IonText>
                    </IonItem>
                </IonCardContent>
            </IonCard>
        </div>
    </SlideContent>
}

export default Section3